var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53638 2.32983L11.8969 10.7911L5.49622 17.6704H6.93674L12.5405 11.6475L17.0682 17.6704H21.9704L15.252 8.73326L21.2097 2.32983H19.7691L14.6084 7.87688L10.4386 2.32983H5.53638ZM7.65479 3.38553H9.90686L19.8516 16.6146H17.5996L7.65479 3.38553Z",
    fill: "#B1B6BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.fcf491d31a7c9c51558941114f8bd93d.svg";
export { ForwardRef as ReactComponent };